import _ from 'lodash';
import { EntityIdToName, Sheet, SheetGroup } from '../../types';
import { produceWithPatches } from 'immer';
import { SheetManagementSet } from '../../types/sheet/draft';

export const getUniqueEntityName = (
  idToName: EntityIdToName,
  isGroup = false
): string => {
  const existingNames: Set<string> = new Set();

  let base = isGroup ? 'Group' : 'Sheet';

  _.values(idToName).forEach((name) => existingNames.add(name.toLowerCase()));

  let newIndex = 1;
  let newName = `${base}${newIndex}`;

  while (existingNames.has(newName.toLowerCase())) {
    newIndex++;
    newName = `${base}${newIndex}`;
  }

  return newName;
};

export const addEntityIdToName = <T extends Sheet | SheetGroup>(
  set: SheetManagementSet,
  entity: T,
  isGroup = false
) => {
  const [updated, changes] = produceWithPatches(
    set.updatedEntityIdToNameMap ?? set.staticEntityIdToNameMap,
    (draft) => {
      if (isGroup) draft.groupsIdToName[entity.id] = entity.name;
      else draft.sheetsIdToName[entity.id] = entity.name;
    }
  );

  set.updatedEntityIdToNameMap = updated;
  if (!set.present.entityIdToNameMapChanges)
    set.present.entityIdToNameMapChanges = [];

  set.present.entityIdToNameMapChanges.push(...changes);
};

export const removeFromEntityIdToName = (
  set: SheetManagementSet,
  id: string,
  isGroup = false
) => {
  const [updated, changes] = produceWithPatches(
    set.updatedEntityIdToNameMap ?? set.staticEntityIdToNameMap,
    (draft) => {
      if (isGroup) delete draft.groupsIdToName[id];
      else delete draft.sheetsIdToName[id];
    }
  );

  set.updatedEntityIdToNameMap = updated;

  if (!set.present.entityIdToNameMapChanges)
    set.present.entityIdToNameMapChanges = [];
  set.present.entityIdToNameMapChanges.push(...changes);
};
